import type { FaireProductEntity } from "../../entity_types/product";

export const p_iaz4zi0d: FaireProductEntity = {
  token: "p_iaz4zi0d",
  type: "product",
  name: "Thanks for Raising Me Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/efc6f486e7e91d67c692bdfc70736432b641060abcdaccb6044353ac8c20b261.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb06065a0906fec35fbbe4f5eb7a521f2c4476c14337557f22830a803dacb834.jpeg",
    "https://cdn.faire.com/fastly/c0facc5093988f45e18aba976974a708ca3aa9558cf5846110245e219a26e2b6.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:17.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
